import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/rule-of-69-calculator',
  component: () => import('../../routes/RuleOf69Calculator.svelte'),
  card: {
    id: 'rule-of-69-calculator',
    title: 'Rule of 69 Calculator',
    description: 'Estimate how long it takes for an investment to double using the Rule of 69 approximation — more accurate than the Rule of 72.',
    icon: 'calculate',
    iconBgClass: 'bg-amber-50',
    iconTextClass: 'text-amber-600',
    href: '/rule-of-69-calculator',
    category: 'Savings & Investing'
  },
  seo: {
    title: 'Rule of 69 Calculator — Estimate Investment Doubling Time',
    description: 'Calculate how long it takes for your money to double using the Rule of 69 approximation. More accurate than the Rule of 72 for continuous compounding.'
  }
};

export default meta;